// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_TGF","left":"styles_left__2Vvzn"};